// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoPro_image__liAFJ","image_in":"LogoPro_image_in__u9jDo"};